import { useMutation, useQueryClient } from '@tanstack/react-query'
import { adminApi } from '../adminApi.js'
import { tenantAuditKey } from './useTenants.js'
import type { SetupLinkResponse } from '../types.js'

export function useRegenerateSetupLink(tenantId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () =>
      adminApi.post<SetupLinkResponse>(`/tenants/${tenantId}/setup-link`),
    onSuccess: () => {
      // The regen writes a setup_link_regenerated audit row — refresh the
      // tenant's recent-activity list so it shows up.
      void qc.invalidateQueries({ queryKey: tenantAuditKey(tenantId) })
    },
  })
}
